/**
 * Criado para servir de interface do gerenciador geral, expondo
 * alguns métodos e atributos que podem existir nos demais gerenciadores
 */
export class ChartManagerInterface {
  formatData(data) { return data };
}